import { render } from "./EmployerRegistration.vue?vue&type=template&id=6e23d2d6&scoped=true"
import script from "./EmployerRegistration.vue?vue&type=script&lang=js"
export * from "./EmployerRegistration.vue?vue&type=script&lang=js"

import "./EmployerRegistration.vue?vue&type=style&index=0&id=6e23d2d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e23d2d6"]])

export default __exports__